import type { LoadedMonaco } from "./types";

let loaded: LoadedMonaco | undefined;
let pending: Promise<LoadedMonaco> | undefined;

/** Returns Monaco once `loadMonaco` has resolved, so already-loaded editors render without a loading frame. */
export const getLoadedMonaco = (): LoadedMonaco | undefined => loaded;

/** Loads Monaco from its own chunk, configured as an npm package instead of from the CDN. Retries after a failure. */
export const loadMonaco = (): Promise<LoadedMonaco> => {
  pending ??= Promise.all([import("monaco-editor"), import("@monaco-editor/react")])
    .then(([monaco, monacoReact]) => {
      // Without this, @monaco-editor/react fetches Monaco from a public CDN
      monacoReact.loader.config({ monaco });
      // Cypress helpers drive editor instances through window.monaco
      Object.assign(window, { monaco });
      loaded = { monaco, Editor: monacoReact.default };
      return loaded;
    })
    .catch((error: unknown) => {
      pending = undefined;
      // Instrumented because a failed Monaco chunk leaves every editor loading. Remove when: never, it is a backstop.
      // If you see this, check that the CDN serves the Monaco chunk and that the deploy finished.
      // The import is dynamic so Sentry stays out of the entry chunks that import this file.
      void import("@sentry/browser").then(({ captureException }) => captureException(error));
      throw error;
    });
  return pending;
};
